import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';

@Injectable({
    providedIn: 'root',
})
export class UserPictureService {
    private domain: string;

    usersPictures: { [key: string]: string } = {};

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    setUserPicture(oid, userName) {
        if (this.usersPictures[oid]) {
            return;
        }

        if (!oid) return;
        let profilePicture = this.createPicture(userName);

        // let { profilePicture } = await lastValueFrom(
        //     this.http.get<any>(`${this.domain}/api/picture-profile/${oid}`),
        // );

        // if (!profilePicture) {
        //  profilePicture = this.createPicture(userName);
        // }

        this.usersPictures[oid] = profilePicture;
    }

    async getUserPicture(oid, userName) {
        this.setUserPicture(oid, userName);
        return this.usersPictures[oid];
    }

    private createPicture(userName: string) {
        const myNames = userName.split(' ');
        let initials;
        if (myNames.length > 1) {
            initials = myNames.shift().charAt(0) + myNames.pop().charAt(0);
        } else {
            initials = myNames.shift().charAt(0);
        }
        const nameInitials = initials.toUpperCase();

        const canvas = document.createElement('canvas');
        const size = 200;
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');

        ctx.fillStyle = this.getRandomColor();
        ctx.fillRect(0, 0, canvas.width, canvas.height);

        ctx.fillStyle = 'white';
        ctx.font = `${canvas.height / 2}px Arial`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';

        ctx.fillText(nameInitials, canvas.width / 2, canvas.height / 2);

        const imageSrc = canvas.toDataURL('image/png');
        return imageSrc;
    }

    private getRandomColor() {
        const letters = '0123456789ABCDEF';
        let color = '#';
        for (let i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        if (color === '#FFFFFF') color = this.getRandomColor();
        return color;
    }
}
